import type { EasyPeasyConfig } from 'easy-peasy';
import { createStore } from 'easy-peasy';

import storeModel from './model';

// Deep import (not the barrel) so the startup store chunk pulls only the tiny
// manager + placement maths, never the React window components.
import { nativeWindowManager } from '~/components/ui/Windows/lib/nativeWindowManager';
import { sentryReduxEnhancer } from '~/lib/sentry/sentryReduxEnhancer';

export const storeConfig: EasyPeasyConfig = {
    name: 'smartlearn',
    version: 1,
    enhancers: [sentryReduxEnhancer],
    injections: {
        // Lets the workspace model's `openInWindow`/`moveToWindow` thunks open a
        // native popup synchronously in the click gesture, without the generic
        // model importing the UI window library.
        nativeWindowManager,
    },
};

export const store = createStore(storeModel, storeConfig);

/**
 * @deprecated Use named import instead
 */
export default store;
